import React, { Component } from 'react';
import { connect } from 'react-redux';
import { /*change as changeFieldValue,*/ reduxForm } from 'redux-form';
import Select from 'react-select';
import { buscarRotasImportacao, limparBuscaRotasImportacao } from '../../actions/rota/importarRotas';
import $ from 'jquery';


export class ModalImportarRotas extends Component {
    constructor(props) {
        super(props);
        this.limparFormulario = this.limparFormulario.bind(this);
        this.fecharModal = this.fecharModal.bind(this);

        this.state = {
            empresaReferencia: null,
            rotasSelecionadas: []
        }

    }

    removerRotaSelecionada(idRota) {
        const rotas = this.state.rotasSelecionadas.filter(it => !(it.id === idRota));
        this.setState({ rotasSelecionadas: rotas });
        if (rotas.length === 0) {
            this.limparFormulario();
        }
    }

    exibirTabela() {
        return (
            <div className='col-12 mt-2'>
                <table className="table table-sm table-bordered">
                    <thead>
                        <tr>
                            <th scope="col">Descrição</th>
                            <th scope="col"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.rotasSelecionadas.length === 0 ?
                            <tr className="alert alert-warning text-center mt-4" role="alert">
                                <td colSpan='4'>
                                    Nenhum item adicionado.
                                </td>
                            </tr>
                            : this.state.rotasSelecionadas.length && this.state.rotasSelecionadas.map(it => (
                                <tr key={it.id}>
                                    <td>{it.descricao}</td>
                                    <td className='text-center' style={{ cursor: 'pointer', color: 'red' }}>
                                        <div onClick={() => this.removerRotaSelecionada(it.id)}>
                                            Remover
                                        </div>
                                    </td>
                                </tr>
                            ))}
                    </tbody>
                </table>
            </div>
        )
    }

    handleEmpresaChange(empresaReferencia) {
        this.setState({ empresaReferencia: empresaReferencia })

        if (empresaReferencia != null) {
            this.props.buscarRotasImportacao(empresaReferencia.value);
        }

        this.setState({ rotasSelecionadas: [] })
    }

    handleRotasSelecionadas(rotaSelecionada) {
        const rotas = this.state.rotasSelecionadas;

        if (this.state.rotasSelecionadas.filter(it => it.id === rotaSelecionada.value).length === 0) {
            rotas.push({
                id: rotaSelecionada.value,
                descricao: rotaSelecionada.label
            });

            this.setState({ rotasSelecionadas: rotas });
        }
    }

    limparFormulario() {
        this.props.reset('formularioImportarRotas');
        this.setState({ empresaReferencia: null, rotasSelecionadas: [] });
        this.props.limparBuscaRotasImportacao();
    }

    montarParametroParaImportarRotas() {
        return {            
            codigoEmpresaOrigem: this.state.empresaReferencia ? this.state.empresaReferencia.value : null,
            rotasOrigem: this.state.rotasSelecionadas ? this.state.rotasSelecionadas.map(rota => rota.id) : null,
        }
    }

    importarRotas() {
        this.props.receberDadosDaImportacao(this.montarParametroParaImportarRotas());        
        this.props.fecharModal(this.fecharModal);
    }
    
    formulario() {        
        return (
            <>
                <form>
                    <div className="row">
                        <div className="col-8 mb-3">
                            <label>Empresa:</label>
                            <Select                                
                                maxMenuHeight={400}
                                menuPlacement="auto"
                                noOptionsMessage={() => ('Nenhuma opção encontrada')}
                                placeholder='Selecione uma empresa'
                                options={this.props.empresas.map(elemento => ({
                                    label: elemento.id === this.props.empresaSelecionada.id
                                        ? `${elemento.nomeFantasia} (própria empresa)`
                                        : elemento.nomeFantasia,
                                    value: elemento.id
                                }))}
                                value={this.state.empresaReferencia ? ({
                                    label: this.state.empresaReferencia.label,
                                    value: this.state.empresaReferencia.value
                                }) : ''}
                                onChange={value => this.handleEmpresaChange(value)}
                            />
                        </div>

                        <div className="col-8 mb-3">
                            <label>Rotas:</label>
                            <Select
                                label="Rotas:"
                                maxMenuHeight={400}
                                menuPlacement="auto"
                                noOptionsMessage={() => ('Nenhuma opção encontrada')}
                                placeholder='Selecione uma rota'
                                options={this.props.rotas.filter(it => !this.state.rotasSelecionadas.map(rota => rota.id).includes(it.id))
                                    .map(elemento => ({
                                        label: elemento.descricao,
                                        value: elemento.id
                                    })
                                    )}
                                value={null}
                                onChange={value => this.handleRotasSelecionadas(value)}
                            />
                        </div>
                    </div>
                    <div className="form-row">
                        {this.exibirTabela()}
                    </div>
                    <div className="modal-footer">
                        <button type="button"
                            data-toggle="modal" data-target="#modalConfirmacaoImportacaoRotas"
                            onClick={() => this.importarRotas()}
                            disabled={this.state.empresaReferencia == null && this.state.rotasSelecionadas.length === 0}
                            className="btn btn-laranja">Salvar</button>
                    </div>
                </form>
            </>
        )
    }

    fecharModal() {
        $('#modalImportarRotas')
            .modal('hide');
        $('#modalImportarRotas')
            .hide();
        $('.modal-backdrop')
            .hide();
        this.limparFormulario();
    }

    render() {
        return (
            <>
                <div className="modal fade show" id='modalImportarRotas' role='dialog'
                    aria-labelledby='modalImportarRotas' aria-hidden='true' data-backdrop='static'>
                    <div className={'modal-dialog modal-dialog-centered modal-xl'}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5>Importar Rotas</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close"
                                    onClick={this.limparFormulario}>
                                    <i className="material-icons">
                                        &#xe5cd;
                                    </i>
                                </button>
                            </div>
                            <div className="modal-body">
                                {this.formulario()}
                            </div>
                        </div>
                    </div>
                </div>                
            </>
        );
    }

}

export const mapStateToProps = (state) => {    
    return {
        empresaSelecionada: state.empresaSelecionada,
        rotas: state.rotasParaImportacao.rotas,        
    }
};

export default connect(mapStateToProps, {
    buscarRotasImportacao,
    limparBuscaRotasImportacao
})(reduxForm({
    form: 'formularioImportarRotas',
    enableReinitialize: true,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
})(ModalImportarRotas));